const ON_CLICK = 'on-click'
const ON_DISPLAY = 'on-display'
const ON_CONTENT = 'on-content'
const ON_VIEWMORE = 'on-viewmore'
const ON_NAVIGATION = 'on-navigation'
const ON_MOVETAB = 'on-movetab'
const EVENT_LIST = 'eventlist'
const ON_ZZIM = 'on-zzim'
const OFF_ZZIM = 'off-zzim'
const ON_INSTANTPLAY = 'on-instantplay'
export {
  ON_CLICK,
  ON_DISPLAY,
  ON_CONTENT,
  ON_VIEWMORE,
  ON_NAVIGATION,
  ON_MOVETAB,
  EVENT_LIST,
  ON_ZZIM,
  OFF_ZZIM,
  ON_INSTANTPLAY
}
